import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
} from "@mui/material";
import parse from "html-react-parser";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FormattedMessage, useIntl } from "react-intl";
import kakaoCoupon from "assets/images/kakao_coupon.webp";
import { OrderType } from "types/orderType";

interface KakoAccordionProps {
  descriptionKey?: string;
  order? :OrderType;
}

const KakaoAccordion = ({ descriptionKey, order }: KakoAccordionProps) => {
  const intl = useIntl();
  const isKorean = intl.locale.toLowerCase().startsWith("ko");
  const isComplete = order?.orderStatus === "COMPLETE";

  return (
    <Accordion
      disableGutters
      sx={{
        width: "100%",
        boxShadow: "none",
        "& .MuiButtonBase-root": { px: 0 },
        "& .MuiAccordionSummary-content": { my: 0 },
        bgcolor: "#0000",
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon fontSize="small" />}
        aria-controls="common.voucherUsage"
        id="common.voucherUsage"
        className="!min-h-8"
        // sx={{
        //   display: "flex",
        //   alignItems: "end",
        // }}
      >
        <p className="text-sm">
          <FormattedMessage id="common.voucherUsage" />
        </p>
      </AccordionSummary>

      <AccordionDetails>
        <div className="leading-3">
          {descriptionKey === "goods.kakaoT" && (
            <>
              <img
                src={kakaoCoupon}
                alt="kakao_coupon"
                height={"480px"}
                style={{ borderRadius: "16px" }}
                onClick={() => window.open(kakaoCoupon)}
              />
              <Divider flexItem sx={{ my: 2 }} />
                {parse(`${intl.formatMessage({ id: descriptionKey })}`)}
            </>
          )}
         {descriptionKey === "goods.lacha" && (
              <div className="space-y-3 leading-relaxed text-[#1F2329]">
                {isKorean ? (
                  <>
                    <p className="text-sm">
                      라차T 포인트는 라차 앱 내에서 제공되는 KTX, 택시, 고속버스 등 교통상품의 예약 및 결제 시 사용할 수 있습니다.
                    </p>
                    <p className="text-sm">
                      쿠폰등록방법 : 라차 앱 {"->"} 마이페이지 {"->"} 라차T등록{" "}
                      {"->"} 쿠폰번호 입력 
                    </p>
                    {!isComplete && (
                      <p className="text-sm">
                        쿠폰번호는 결제 후 주문상세 페이지에서 확인할 수 있습니다.
                      </p>
                    )}
                    {isComplete && (
                      <p className="font-bold">
                        쿠폰번호 : {order.goodsList?.serialCode}
                      </p>
                    )}
                    <p className="text-sm">
                      이용권 쿠폰번호를 라차 앱에 등록한 경우, 어떠한 경우에도 환불이 불가합니다.
                    </p>
                    <p className="text-sm">
                      라차T 이용권은 옵션 상품으로, 단독 취소가 불가합니다. (기차와 함께 취소해야 합니다.)
                    </p>
                    
                  </>
                ) : (
                  <>
                    <p className="text-sm">
                      Lacha T points can be used when booking and paying for transportation products 
                      such as KTX, taxis, and express buses within the Lacha app.
                    </p>
                    <p className="text-sm">
                      How to register a coupon: Lacha App {"->"} My Page {"->"} Lacha T Registration {"->"} Enter coupon code
                    </p>
                    {!isComplete && (
                      <p className="text-sm">
                        The coupon code can be found on the order detail page after payment.
                      </p>
                    )}
                    {isComplete && (
                      <p className="font-bold">
                        Coupon Code : {order.goodsList?.serialCode}
                      </p>
                    )}
                    <p className="text-sm">
                      If the voucher PIN has been registered in the Lacha app, it is non-refundable under any circumstances.
                    </p>
                    <p className="text-sm">
                      Lacha T vouchers are optional add-on products and cannot be canceled separately. (They must be canceled together with the train ticket.)
                    </p>
                  </>
                )}
              </div>
          )}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default KakaoAccordion;
